define('CustomBowls.View', [
  'PageType.Base.View',
  'Item.Collection',
  'Backbone',
  'Utils',
  'jQuery',
  'custom_bowls_landing.tpl'
], function (
  PageType,
  ItemCollection,
  Backbone,
  Utils,
  jQuery,
  template
) {
  'use strict';

  return PageType.PageTypeBaseView.extend({

    template: template,

    initialize: function (options) {
      this.options = options || {};
      this.pageState = {
        isLoading: true,
        errorMessage: null
      };
      this.cartProcessingStarted = false;
    },

    // Resolves immediately so the framework renders the view right away,
    // showing the loading spinner while the cart work happens in the background.
    beforeShowContent: function () {
      return jQuery.Deferred().resolve().promise();
    },

    // On the first render, kicks off the add-to-cart flow.
    render: function () {
      PageType.PageTypeBaseView.prototype.render.call(this);
      if (!this.cartProcessingStarted) {
        this.cartProcessingStarted = true;
        this.processCustomBowl();
      }
      return this;
    },

    // Parses query parameters from the current URL.
    // Handles both hash-based (/#custombowl?buyid=X) and pushState (/custombowl?buyid=X) routing.
    parseUrlParameters: function () {
      var queryString = '';

      var urlHash = window.location.hash || '';
      if (urlHash.indexOf('?') >= 0) {
        queryString = urlHash.split('?')[1];
      }

      if (!queryString && window.location.search) {
        queryString = window.location.search.replace('?', '');
      }

      var parameters = {};

      if (!queryString) {
        return parameters;
      }

      var pairs = queryString.split('&');
      for (var i = 0; i < pairs.length; i++) {
        var equalsIndex = pairs[i].indexOf('=');
        if (equalsIndex < 1) {
          continue;
        }
        var key = decodeURIComponent(pairs[i].slice(0, equalsIndex).replace(/\+/g, ' '));
        var value = decodeURIComponent(pairs[i].slice(equalsIndex + 1).replace(/\+/g, ' '));
        parameters[key] = value;
      }

      return parameters;
    },

    showError: function (message) {
      this.pageState.isLoading = false;
      this.pageState.errorMessage = message;
      this.render();
    },

    // Builds the cart line options array directly from the custcol* URL parameters.
    // The external bowl configurator sends each value already as the Item Option's
    // internal id (for select options) or as free text, so no product/options lookup
    // is needed. The Cart Component validator requires each option to be
    // { cartOptionId: 'custcolXX', value: { internalid: '<string>' } } — note the
    // value MUST be an object, not a raw string.
    buildLineOptions: function (customColParameters) {
      var lineOptions = [];

      for (var paramName in customColParameters) {
        if (!Object.prototype.hasOwnProperty.call(customColParameters, paramName)) {
          continue;
        }

        var rawValue = customColParameters[paramName];
        if (rawValue === null || typeof rawValue === 'undefined' || rawValue === '') {
          continue;
        }

        lineOptions.push({
          cartOptionId: paramName,
          value: { internalid: String(rawValue) }
        });
      }

      return lineOptions;
    },

    // Fetches the item, applies the custcol options coming from the URL and adds the
    // resulting line to the cart, then redirects to the cart page.
    processCustomBowl: function () {
      var self = this;
      var parameters = this.parseUrlParameters();
      var buyId = parseInt(parameters.buyid, 10);
      var quantity = parseInt(parameters.qty, 10);

      if (!buyId || isNaN(buyId) || buyId < 1) {
        self.showError(Utils.translate('No bowl item was specified in the request URL.'));
        return;
      }

      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      }

      var customColParameters = {};
      for (var paramName in parameters) {
        if (Object.prototype.hasOwnProperty.call(parameters, paramName) && paramName.indexOf('custcol') === 0) {
          customColParameters[paramName] = parameters[paramName];
        }
      }

      var itemCollection = new ItemCollection();

      itemCollection.fetch({
        data: { id: buyId },

        success: function (collection) {
          var itemModel = collection.at(0);

          if (!itemModel) {
            self.showError(Utils.translate('The requested bowl could not be found.'));
            return;
          }

          var cart = self.options.container.getComponent('Cart');

          cart.addLine({
            line: {
              item: {
                internalid: buyId,
                type: itemModel.get('itemtype')
              },
              quantity: quantity,
              options: self.buildLineOptions(customColParameters)
            }
          }).then(
            function () {
              Backbone.history.navigate('cart', { trigger: true });
            },
            function (error) {
              self.showError(
                (error && error.message) ||
                Utils.translate('An error occurred while adding your custom bowl to the cart.')
              );
            }
          );
        },

        error: function () {
          self.showError(Utils.translate('An error occurred while looking up your custom bowl. Please try again.'));
        }
      });
    },

    getContext: function () {
      return {
        isLoading: this.pageState.isLoading,
        errorMessage: this.pageState.errorMessage
      };
    }

  });
});
